/*global $, app, me*/
"use strict";

var _ = require('underscore');
var HumanView = require('human-view');
var templates = require('../templates');

module.exports = HumanView.extend({
    template: templates.includes.mucListItem,
    classBindings: {
        activeContact: '',
        hasUnread: '',
        joined: '',
        persistent: ''
    },
    textBindings: {
        displayName: '.name',
        displayUnreadCount: '.unread'
    },
    events: {
        'click': 'handleClick',
        'click .join': 'handleJoinRoom',
        'click .remove': 'handleLeaveRoom'
    },
    render: function render() {
        this.renderAndBind({ contact: this.model });
        return this;
    },
    handleClick: function handleClick(e) {
        app.navigate('groupchat/' + encodeURIComponent(this.model.jid));
    },
    handleJoinRoom: function handleJoinRoom(e) {
        this.model.join();
    },
    handleLeaveRoom: function handleLeaveRoom(e) {
        var muc = this.model;
        muc.leave();
    }
});


//////////////////
// WEBPACK FOOTER
// ./views/mucListItem.js
// module id = 801
// module chunks = 2